import { FC, Fragment } from 'react'

import { InfoField } from 'types/infoField'

import { InfoFieldBlock, InfoFieldTitle } from './styles'

interface InfoFieldsProps {
  fields: InfoField[]
}

const InfoFields: FC<InfoFieldsProps> = ({ fields }) => (
  <>
    {fields?.map(({ child, content, key, title }) => (
      <Fragment key={key}>
        {!child ? (
          <InfoFieldBlock>
            <InfoFieldTitle>{title}</InfoFieldTitle>
            {content}
          </InfoFieldBlock>
        ) : (
          child
        )}
      </Fragment>
    ))}
  </>
)

export default InfoFields
